// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"854cceac","147":"69162a27","312":"79e4230e","363":"e3a9f905","461":"b2926172","526":"f6322224","667":"4e888e03","897":"3fd9b869"}[chunkId] + ".chunk.js";
};